var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guideImage"},[_c('img',{attrs:{"src":_vm.image,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }